import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

/**
 * Generated class for the PrettydatePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'prettydate',
})
export class PrettydatePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    var date = moment(value);
    date.locale('fr');
    return date.format('lll');
  }
}



// WEBPACK FOOTER //
// ./src/pipes/prettydate/prettydate.ts